import React, { useState } from "react";
import { Button, Table } from "reactstrap";

import { default as EditUserProfileModal } from "./modals/EditUserProfileModal";

const UserDetailsTableComponent = props => {
  const { activateModal } = props;
  const [ user, setUser ] = useState(props.user);

  return (
    <Table className="text-center" size="sm" hover>
      <tbody>
        <tr>
          <td className="text-left">Name</td>
          <td className="text-right">
            {user.personal.name}
          </td>
        </tr>
        <tr>
          <td className="text-left">Role</td>
          <td className="text-right">
            {user.roles}
          </td>
        </tr>
        <tr>
          <td className="text-left">Email</td>
          <td className="text-right">
            {user.local.email}
          </td>
        </tr>
        <tr>
          <td className="text-left">Password</td>
          <td className="text-right">
            *******
          </td>
        </tr>
        <tr>
          <td className="text-left">Phone Number</td>
          <td className="text-right">
            {user.personal.phoneNumber}
          </td>
        </tr>
        <tr>
          <Button
            className="btn btn-block"
            onClick={() => activateModal("editUserProfileModal")}
          >
            Edit Details
          </Button>
          <EditUserProfileModal user={user} setUser={setUser} />
        </tr>
      </tbody>
    </Table>
  );
};

export default UserDetailsTableComponent;
